import { Component, OnInit } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { config, PartnerService } from '@fgb/core';
@Component({
  selector: 'fgb-refer-a-friend-page',
  templateUrl: './refer-a-friend-page.component.html',
  styleUrls: ['./refer-a-friend-page.component.scss'],
})
export class ReferAFriendPageComponent implements OnInit {
  loading: boolean = false;
  referAFriendForm: FormGroup;
  url: any;
  code: any;
  referralCode: any;
  toggle: boolean = false;
  linktoggle: boolean = false;
  successFlag: boolean = false;

  constructor(
    private clipboard: Clipboard,
    private partnerService: PartnerService,
    private formBuilder: FormBuilder
  ) {}
  ngOnInit() {
    this.setFormControls();
    this.getFriendLink();
  }
  setFormControls() {
    this.referAFriendForm = this.formBuilder.group({
      fullname: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }
  get f() {
    return this.referAFriendForm.controls;
  }
  getFriendLink() {
    this.partnerService.getFriendLink().subscribe({
      next: (data: any) => {
        this.url = `${config.portalUrl}` + '/register/referafriend?friendKey=' + data.Data;
        this.code = data.Data;
      },
      error: (err: any) => console.log(err),
    });
  }
  sendReferral(payload: any): void {
    this.loading = true;
    const emailAddress = payload.email;
    const fullname = payload.fullname;
    this.partnerService.sendReferFriendLink(emailAddress, fullname).subscribe((response) => {
      this.successFlag = true;
    });
  }
  copyCodeToClipboardLowercase(text: any): void {
    this.linktoggle = true;
    setTimeout(() => {
      this.linktoggle = false;
    }, 2000);
    this.clipboard.copy(text.toLowerCase());
  }
  copyCodeToClipboardUppercase(text: any): void {
    this.toggle = true;

    setTimeout(() => {
      this.toggle = false;
    }, 2000);
    this.clipboard.copy(text.toUpperCase());
  }
}
